import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { DataStoreResourceType } from "../../../../utils/constants";
import { DataStoreResourceTypeIconsAndLabels } from "../utils";

export const getDataStoreColumns = (colors) => ({
  type: {
    field: "resource_type",
    headerName: "Type",
    minWidth: 165,
    flex: 0.5,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    resizable: false,
    valueGetter: (params) => {
      if (params.row?.resource_type) return params.row.resource_type;
      else if (params.row?.azure_sql_database_data?.resource_type)
        return params.row.azure_sql_database_data.resource_type;
      else if (params.row?.azure_storage_account_data?.resource_type)
        return params.row.azure_storage_account_data.resource_type;
      else if (params.row?.azure_blob_container_data?.resource_type)
        return params.row.azure_blob_container_data.resource_type;
      else if (params.row?.azure_file_share_data?.resource_type)
        return params.row.azure_file_share_data.resource_type;
      else if (params.row?.azure_queue_data?.resource_type)
        return params.row.azure_queue_data.resource_type;
      else if (params.row?.azure_table_data?.resource_type)
        return params.row.azure_table_data.resource_type;
      else if (params.row?.checkmarx_data)
        return DataStoreResourceType.REPOSITORY;
      return null;
    },
    valueFormatter: (params) => {
      if (!params.value) return null;
      if (!DataStoreResourceTypeIconsAndLabels[params.value])
        return params.value;
      const [, label] = DataStoreResourceTypeIconsAndLabels[params.value];
      return label;
    },
    renderCell: (params) => {
      if (!params.value) return "-";
      if (!DataStoreResourceTypeIconsAndLabels[params.value]) {
        return (
          <Box display="flex" alignItems="center">
            <Typography variant="caption" color={colors.grey_700}>
              {params.value}
            </Typography>
          </Box>
        );
      }

      const [Icon, label] = DataStoreResourceTypeIconsAndLabels[params.value];
      return (
        <Box display="flex" alignItems="center" gap={1}>
          <SvgToIcon IconLogo={Icon} width={"24px"} />
          <Typography variant="caption" color={colors.grey_700}>
            {label}
          </Typography>
        </Box>
      );
    },
  },
  public_access: {
    field: "public_access",
    headerName: "Public Access",
    minWidth: 140,
    flex: 0.5,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    resizable: false,
    valueGetter: (params) => {
      return params.row.public_permissions === undefined ||
        params.row.public_permissions === null
        ? null
        : params.row.public_permissions.length > 0;
    },
    valueFormatter: (params) =>
      params.value == null ? "-" : params.value ? "Exposed" : "Not Exposed",
    renderCell: (params) => (
      <Typography variant="caption" color={colors.grey_700}>
        {params.value == null ? "-" : params.value ? "Exposed" : "Not Exposed"}
      </Typography>
    ),
  },
  vulnerabilities: {
    field: "vulnerability_count",
    headerName: "Vulnerabilities",
    minWidth: 140,
    flex: 0.5,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    valueGetter: (params) => {
      return params.row.vulnerability_count || 0;
    },
    valueFormatter: (params) => params.value.toString(),
    renderCell: (params) => (
      <Typography variant="caption">{params.value}</Typography>
    ),
  },
});
